import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import('../views/Main.vue'),
  },
  {
    path: '/en',
    name: 'Main',
    component: () => import('../views/Main.vue'),
  },
  {
    path: '/technology',
    name: 'Technology',
    component: () => import('../views/Technology.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/product/wearable',
    name: 'productWearable',
    component: () => import('../views/ProductWearable.vue'),
  },
  {
    path: '/product/baby',
    name: 'ProductBaby',
    component: () => import('../views/ProductBaby.vue'),
  },
  {
    path: '/product/bed',
    name: 'ProductBed',
    component: () => import('../views/ProductBed.vue'),
  },
  {
    path: '/product/golf',
    name: 'ProductGolf',
    component: () => import('../views/ProductGolf.vue'),
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() { // 스크롤 최상단으로 이동
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.path === '/en') {
    sessionStorage.setItem('langCode', 'en');
    next('/');
    return;
  }
  next();
});

export default router;
